import React from 'react';
import { useJixxeoRecorder } from '../../context/RecorderContext';
import { Pause, Play, Square, Mic, Monitor } from 'lucide-react';
import { formatDuration } from '../../lib/recordingsDb';

export default function RecordingControls() {
  const rec = useJixxeoRecorder();
  if (!rec) return null;
  if (rec.state !== 'recording' && rec.state !== 'paused') return null;

  return (
    <div
      data-testid="recording-controls"
      className="fixed top-3 left-1/2 -translate-x-1/2 z-[70] glass rounded-full px-3 py-1.5 flex items-center gap-2 shadow-2xl shadow-red-500/20 border border-red-500/40"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className={`animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 ${rec.state === 'paused' ? 'hidden' : ''}`} />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
      </span>
      <span data-testid="controls-timer" className="font-mono text-sm font-bold tabular-nums">{formatDuration(rec.elapsed)}</span>
      <span className="hidden sm:inline text-[10px] uppercase tracking-wider text-slate-300 border-l border-white/10 pl-2 flex items-center gap-1">
        <Monitor className="w-3 h-3" /> screen
        {rec.micActive && <><Mic className="w-3 h-3 ml-1" /> mic</>}
        {rec.tabAudioActive && <span className="ml-1">+ tab audio</span>}
      </span>
      {rec.pauseSupported && (
        rec.state === 'recording' ? (
          <button data-testid="pause-recording" onClick={rec.pause} className="p-1.5 rounded-full hover:bg-white/10" title="Pause"><Pause className="w-4 h-4" /></button>
        ) : (
          <button data-testid="resume-recording" onClick={rec.resume} className="p-1.5 rounded-full hover:bg-white/10" title="Resume"><Play className="w-4 h-4" /></button>
        )
      )}
      <button data-testid="stop-recording" onClick={rec.stopAndPreview} className="px-2 py-1 rounded-full bg-red-600 hover:bg-red-500 text-white text-xs font-bold flex items-center gap-1">
        <Square className="w-3 h-3" /> Stop
      </button>
    </div>
  );
}
